/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import styled from 'styled-components';
import Theme from '../Theme';
import { Icon } from '@tillersystems/stardust';

/**
 * StepMenu
 *
 * This component is in charge of displaying
 * a step menu
 *
 * @return {jsx}
 */
export const StepMenu = ({ show, className, step, handleClick, t }) => {
  const getStepName = current =>
    ({
      1: t('navigation.informations'),
      2: t('navigation.order'),
      3: t('navigation.delivery'),
      4: t('navigation.training'),
    }[current]);

  if (step.current === 0 || step.current >= step.total) {
    return null;
  } else {
    return (
      <React.Fragment>
        <div className={className} onClick={handleClick}>
          {step.current}/{step.total - 1}. {getStepName(step.current)}
          <Icon
            name={show ? 'chevron-top' : 'chevron-down'}
            color={Theme.palette.primary.default}
          />
        </div>
      </React.Fragment>
    );
  }
};

/**
 * PropTypes Validation
 */
const { object, string } = PropTypes;
StepMenu.propTypes = {
  className: string,
  step: object.isRequired,
};

/**
 * Default Props
 */
StepMenu.defaultProps = {
  className: '',
};

/** Defines the mapping Redux store to props. */
const mapStateToProps = ({ step }) => {
  return {
    step,
  };
};

const StepMenuConnect = connect(mapStateToProps)(styled(StepMenu)`
  color: ${({ theme: { palette } }) => palette.primary.default};
  cursor: pointer;
  font-weight: ${({ theme: { fonts } }) => fonts.weight.thick};
  display: flex;
  align-items: center;
`);

export default translate('translations')(StepMenuConnect)



// WEBPACK FOOTER //
// ./src/components/StepMenu/index.js